import { Cheers, IMedia, Media, Reaction, User } from './index'

export const PostPriority = [ 'high', 'normal' ] as const
export const PostType = [ 'post', 'story', 'announcement' ] as const
export const PostVisibility = [ 'public', 'followers', 'friends' ] as const
export interface IPost {
  _id: string

  title: string
  content: string
  visibility: typeof PostVisibility[number]

  owner: string
  parent: string
  event: string
  group: string

  isSpicy?: boolean

  attachments?: {
    link?: string
    question?: string
    event?: string
    group?: string
    token?: string
    post?: string
    youtube?: string
    spotify?: string
    medias?: IMedia[]
    spoiler?: {
      images?: string[]
      text?: string
    }
    poll?: {
      options: [
        {
          _id: string
          label: string
          voters: string[]
        }
      ]
    }  
  }

  promotion: {
    link: string
    linkTitle: string
  } | null
  
  posts: string[]
  reactions: Reaction[]
  cheers: Cheers[]
  flairs: string[]

  lang: string
  translations: { [key: string]: string }

  popularity: number

  type: typeof PostType[number]
  priority?: typeof PostPriority[number]
  isPinned: boolean

  metadata?: {
    isSuggestion?: boolean
  }

  createdAt: Date
  sentimentCount?: number
  scoreCustom?: number

  // VIRTUALS

  votes: number
  
  ['@posts']?: IPost[]
  ['@parent']?: IPost

  postsCount?: number
}

export interface Post extends IPost {}

export class Post implements IPost {
  medias: (Media & { isSpoiler: boolean })[]
  ['@posts']: Post[]
  
  constructor (props: IPost) {

    Object.assign(this, {
      ...props,
      ['@posts']: (props['@posts'] ?? []).map(p => new Post(p)).sort((a, b) => Number(a.createdAt) - Number(b.createdAt)),
      reactions: (props.reactions ?? []),
      cheers: (props.cheers ?? []),
      medias: props.attachments?.medias ? props.attachments.medias.map(m => {
        const media = new Media(m)

        if ((props.attachments?.spoiler?.images ?? []).includes(media._id)) (media as any).isSpoiler = true

        return media
      }) : []
    })
  }

  public translated (user: User | null, excludedIds?: string[]) {
    const isTranslationsEnabled = user?.isLangTranslate && !(user?.langExcluded ?? []).includes(this.lang ?? '') && !(excludedIds ?? []).includes(this._id)

    return {
      title: (isTranslationsEnabled ? this.translations?.title : undefined) ?? this.title ?? '',
      content: (isTranslationsEnabled ? this.translations?.content : undefined) ?? this.content ?? ''
    }
  }
}